/**
 * AutomationToggle Component
 * Toggle for showing/hiding automation lanes
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Sliders } from 'lucide-react';

export const AutomationToggle = ({
  showAutomation,
  setShowAutomation,
}) => {
  return (
    <Button
      variant={showAutomation ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setShowAutomation(!showAutomation)}
      className={`relative p-2 ${showAutomation ? 'bg-orange-500/20 text-orange-400 border border-orange-500/50' : 'text-zinc-400 hover:text-white'}`}
      data-testid="automation-toggle"
      title={showAutomation ? 'Hide Automation' : 'Show Automation'}
    >
      <Sliders className="w-5 h-5" />
    </Button>
  );
};

export default AutomationToggle;
